import script from "./MobileAction.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileAction.vue?vue&type=script&setup=true&lang=js"

import "./MobileAction.vue?vue&type=style&index=0&id=c55f92c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c55f92c2"]])

export default __exports__